(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-profile/assets/javascripts/views/pages/profile.js') >= 0) return;  svs.modules.push('/modules/player-profile/assets/javascripts/views/pages/profile.js');

'use strict';

svs.player_profile.views.Profile = Marionette.View.extend({
  getTemplate() {
    if (this.getOption('isSubpage')) {
      return svs.player_profile.templates.profile_subpage;
    }
    return svs.player_profile.templates.profile;
  },
  templateContext() {
    return {
      viewData: {
        pageTitle: this.getOption('pageTitle'),
        backLinkText: this.getOption('backLinkText') || 'Uppgifter',
        backLinkUrl: this.getOption('backLinkUrl') || '/uppgifter'
      }
    };
  },
  regions: {
    containerRegion: '#containerRegion'
  },
  behaviors: {
    ComponentLoaderPromise: {
      behaviorClass: svs.player_profile.behaviors.ComponentLoaderPromise,
      hideErrors: !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) 
    },
    Navigation: {
      behaviorClass: svs.player_profile.behaviors.Navigation
    },
    ServerSideRendering: {
      behaviorClass: svs.app.ServerSideHelper.ServerSideRendering,
      regionSetup() {
        return {
          containerRegion: {
            view: svs.accountservices.player_details.start,
            options: {
              action: this.getOption('action'),
              onNavigation: route => {
                svs.player_profile.router.navigateIfRoute(route);
              },
              pokerClient: this.getOption('pokerClient'),
              returnUrl: this.getOption('returnUrl'),
              urlList: this.getOption('urlList')
            }
          }
        };
      }
    }
  }
});

 })(window);